<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiCheckCircleOutline } from "@mdi/js";
export default {
  name: "MdiCheckCircleOutline",
  data() {
    return {
      svgPath: mdiCheckCircleOutline,
    };
  },
};
</script>
